function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_vm._v("Match offline data with online behavior")]),_vm._v(" "),_c('p',[_vm._v("Both Google and Facebook fail to track them properly, but WhiteBox could help them.\nOptimize your campaigns to target phone calls and exclude already called in to save money.\nWhiteBox tracks all the anonymous visitors on your website over multiple sessions and devices, traffic sources and keywords.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home/conversions","image":"/img/conversions.svg","summary":"Optimize your campaigns to target offline conversions"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }